import { css } from '@emotion/core';

export const globalStyles = css`
  html {
    margin: 0;
    padding: 0;
    font-size: 62.5%;
    scroll-behavior: smooth;
  }
  body {
    margin: 0;
    padding: 0;
    font-size: 1.4rem;
    font-family: 'RaleWay', 'Helvetica', 'Arial', sans-serif !important;
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
    -webkit-overflow-scrolling: touch;
  }
  button {
    padding: 0;
    user-select: none;
  }
  * {
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -moz-tap-highlight-color: rgba(0, 0, 0, 0);
  }
`;
